// extracted by mini-css-extract-plugin
module.exports = {"words":"five-star-words-module--words--ByjoR","container":"five-star-words-module--container--1TyZS"};